<div class="wrapper-multi-progress multi-progress_calc">
  <div class="multi-progress">
    @if (!data.items || data.items.length == 0) {
      <progress-bar [value]="0">
      </progress-bar>
    }

    @for (item of data.items || []; track $index) {
      <stacked-progress-bar [min]="item.min"
        [max]="item.max"
        [mainLegend]="item.mainLegend"
        [data]="item.data"
        [width]="(item.max-item.min) / data.sum * (data.items.length>1 ? (100 - (data.items.length - 1) * 2) : 100)">
      </stacked-progress-bar>
    }
  </div>
</div>
